export class LogInModel {
    mobileNumber : string;
    password: string;
  }